/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@shopify/theme-currency/currency.js":
/*!**********************************************************!*\
  !*** ./node_modules/@shopify/theme-currency/currency.js ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   formatMoney: () => (/* binding */ formatMoney)\n/* harmony export */ });\n/**\n * Currency Helpers\n * -----------------------------------------------------------------------------\n * A collection of useful functions that help with currency formatting\n *\n * Current contents\n * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.\n *\n */\n\nconst moneyFormat = '${{amount}}';\n\n/**\n * Format money values based on your shop currency settings\n * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents\n * or 3.00 dollars\n * @param  {String} format - shop money_format setting\n * @return {String} value - formatted value\n */\nfunction formatMoney(cents, format) {\n  if (typeof cents === 'string') {\n    cents = cents.replace('.', '');\n  }\n  let value = '';\n  const placeholderRegex = /\\{\\{\\s*(\\w+)\\s*\\}\\}/;\n  const formatString = format || moneyFormat;\n\n  function formatWithDelimiters(\n    number,\n    precision = 2,\n    thousands = ',',\n    decimal = '.'\n  ) {\n    if (isNaN(number) || number == null) {\n      return 0;\n    }\n\n    number = (number / 100.0).toFixed(precision);\n\n    const parts = number.split('.');\n    const dollarsAmount = parts[0].replace(\n      /(\\d)(?=(\\d\\d\\d)+(?!\\d))/g,\n      `$1${thousands}`\n    );\n    const centsAmount = parts[1] ? decimal + parts[1] : '';\n\n    return dollarsAmount + centsAmount;\n  }\n\n  switch (formatString.match(placeholderRegex)[1]) {\n    case 'amount':\n      value = formatWithDelimiters(cents, 2);\n      break;\n    case 'amount_no_decimals':\n      value = formatWithDelimiters(cents, 0);\n      break;\n    case 'amount_with_comma_separator':\n      value = formatWithDelimiters(cents, 2, '.', ',');\n      break;\n    case 'amount_no_decimals_with_comma_separator':\n      value = formatWithDelimiters(cents, 0, '.', ',');\n      break;\n  }\n\n  return formatString.replace(placeholderRegex, value);\n}\n\n\n//# sourceURL=webpack://adams-theme/./node_modules/@shopify/theme-currency/currency.js?");

/***/ }),

/***/ "./src/js/collection.js":
/*!******************************!*\
  !*** ./src/js/collection.js ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _utility_open_addtocart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utility/open-addtocart */ \"./src/js/utility/open-addtocart.js\");\n/* harmony import */ var _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @shopify/theme-currency */ \"./node_modules/@shopify/theme-currency/currency.js\");\n/* harmony import */ var _css_collection_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../css/collection.css */ \"./src/css/collection.css\");\n/**\n * Collection page specific scripts and styles\n */\n\n\n\nconsole.log('hello');\nvar productContainer = document.getElementById(\"product-container\");\nvar paginationContainer = document.getElementById(\"pagination\");\nvar preloader = document.getElementById(\"preloader\");\nvar perPageSelect = document.getElementById(\"items-per-page\");\nvar totalProducts = parseInt(document.getElementById(\"total-products\").value, 10);\nvar sortSelect = document.getElementById(\"sort-by\"); // Sorting dropdown\n\nvar addToCartText = document.getElementById(\"add-to-cart-text\").value;\nvar hasCartBtn = document.getElementById(\"has-cart\").value;\nvar perPage = parseInt(localStorage.getItem(\"per_page\")) || 12;\nvar currentPage = 1;\nvar totalPages = 1;\nvar sortOption = localStorage.getItem(\"sort_option\") || \"best-selling\"; // Default sort\n\nperPageSelect.value = perPage;\n// sortSelect.value = sortOption; // Set default sort option\n\nfunction showPreloader() {\n  preloader.style.display = \"flex\";\n}\nfunction hidePreloader() {\n  preloader.style.display = \"none\";\n}\nfunction fetchProducts(page) {\n  showPreloader();\n  var collectionHandle = window.location.pathname.split(\"/\").pop();\n  var url = \"/collections/\".concat(collectionHandle, \"/products.json?limit=\").concat(perPage, \"&page=\").concat(page);\n  console.log(\"Fetching: \".concat(url));\n  fetch(url).then(function (response) {\n    return response.json();\n  }).then(function (data) {\n    totalPages = Math.ceil(totalProducts / perPage);\n    updateProductList(data.products);\n    updatePagination();\n    (0,_utility_open_addtocart__WEBPACK_IMPORTED_MODULE_0__[\"default\"])();\n  })[\"catch\"](function (error) {\n    return console.error(\"Error fetching products:\", error);\n  })[\"finally\"](hidePreloader);\n}\nfunction updateProductList(products) {\n  var productList = document.getElementById(\"product-list\");\n  productList.innerHTML = \"\";\n  products.forEach(function (product) {\n    var firstVariant = product.variants[0];\n    var isAvailable = firstVariant.available;\n    var hasMultipleVariants = product.variants.length > 1;\n    var priceFormatted = (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(firstVariant.price, window.theme.moneyFormat);\n    var variantsHTML = \"\";\n    if (hasMultipleVariants) {\n      variantsHTML = \"<div class=\\\"size-list-container\\\">\\n        <ul class=\\\"size-list btn-boxed\\\">\";\n      product.variants.forEach(function (variant) {\n        variantsHTML += \"\\n          <li>\\n            <div class=\\\"add-to-cart-popup\\\"\\n                 data-id=\\\"\".concat(variant.id, \"\\\"\\n                 data-text=\\\"\").concat(variant.title, \" - \").concat((0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(variant.price, window.theme.moneyFormat), \"\\\"\\n                 \").concat(variant.available ? \"\" : \"data-disabled\", \">\\n            </div>\\n          </li>\");\n      });\n      variantsHTML += \"</ul>\\n        <button class=\\\"hover:underline btn-boxed p-1 px-2 product-image-atc\\\">\\n          \".concat(addToCartText, \"\\n        </button>\\n      </div>\");\n    } else {\n      variantsHTML = \"\\n        <div class=\\\"add-to-cart-popup\\\"\\n             data-id=\\\"\".concat(firstVariant.id, \"\\\"\\n             data-text=\\\"\").concat(addToCartText, \"\\\"\\n             data-button\\n             \").concat(isAvailable ? \"\" : \"data-disabled\", \">\\n        </div>\");\n    }\n    var productHTML = \"\\n      <div class=\\\"text-center product-thumbnail product-item\\\">\\n        <a href=\\\"/products/\".concat(product.handle, \"\\\" class=\\\"product-image-link\\\">\\n          <div class=\\\"image-1\\\">\\n            <img src=\\\"\").concat(product.images[0].src, \"\\\" class=\\\"image-shadow aspect-square object-contain\\\">\\n          </div>\\n        </a>\\n        <div class=\\\"m-2 flex flex-col gap-1\\\">\\n          \").concat(hasCartBtn === 'true' ? variantsHTML : '', \"\\n          <h2 class=\\\"large__text w-full leading-tight\\\" style=\\\"text-align: center;\\\">\\n            <a href=\\\"/products/\").concat(product.handle, \"\\\">\").concat(product.title, \"</a>\\n          </h2>\\n          <p class=\\\"small__text mt-0\\\">\\n            \").concat(priceFormatted, \"\\n            \").concat(isAvailable ? \"\" : \" - <strong>sold out</strong>\", \"\\n          </p>\\n        </div>\\n      </div>\\n    \");\n    productList.insertAdjacentHTML(\"beforeend\", productHTML);\n  });\n}\nfunction updatePagination() {\n  paginationContainer.innerHTML = \"\";\n  var prevButton = document.createElement(\"button\");\n  prevButton.textContent = \"←\";\n  prevButton.disabled = currentPage === 1;\n  prevButton.addEventListener(\"click\", function () {\n    if (currentPage > 1) {\n      currentPage--;\n      fetchProducts(currentPage);\n    }\n  });\n  paginationContainer.appendChild(prevButton);\n  var _loop = function _loop(i) {\n    if (i === 1 || i === totalPages || i >= currentPage - 1 && i <= currentPage + 1) {\n      var pageButton = document.createElement(\"button\");\n      pageButton.textContent = i;\n      pageButton.classList.add(\"page-number\");\n      if (i === currentPage) {\n        pageButton.classList.add(\"active\");\n      }\n      pageButton.addEventListener(\"click\", function () {\n        currentPage = i;\n        fetchProducts(currentPage);\n      });\n      paginationContainer.appendChild(pageButton);\n    } else if (i === currentPage - 2 || i === currentPage + 2) {\n      var dots = document.createElement(\"span\");\n      dots.textContent = \"...\";\n      dots.classList.add(\"dots\");\n      paginationContainer.appendChild(dots);\n    }\n  };\n  for (var i = 1; i <= totalPages; i++) {\n    _loop(i);\n  }\n  var nextButton = document.createElement(\"button\");\n  nextButton.textContent = \"→\";\n  nextButton.disabled = currentPage >= totalPages;\n  nextButton.addEventListener(\"click\", function () {\n    if (currentPage < totalPages) {\n      currentPage++;\n      fetchProducts(currentPage);\n    }\n  });\n  paginationContainer.appendChild(nextButton);\n}\n\n// Handle per-page selection\nperPageSelect.addEventListener(\"change\", function () {\n  perPage = parseInt(perPageSelect.value);\n  localStorage.setItem(\"per_page\", perPage);\n  currentPage = 1;\n  fetchProducts(currentPage);\n});\n\n// // Handle sorting selection\n// sortSelect.addEventListener(\"change\", function () {\n//   sortOption = sortSelect.value;\n//   localStorage.setItem(\"sort_option\", sortOption);\n//   currentPage = 1;\n//   fetchProducts(currentPage);\n// });\n\nfetchProducts(currentPage);\n\n//# sourceURL=webpack://adams-theme/./src/js/collection.js?");

/***/ }),

/***/ "./src/js/utility/open-addtocart.js":
/*!******************************************!*\
  !*** ./src/js/utility/open-addtocart.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"default\": () => (__WEBPACK_DEFAULT_EXPORT__)\n/* harmony export */ });\nvar openAddToCart = function openAddToCart() {\n  return Promise.all(/*! import() | addtocart-init */[__webpack_require__.e(\"vendors-node_modules_svelte_internal_index_mjs\"), __webpack_require__.e(\"addtocart-init\")]).then(__webpack_require__.bind(__webpack_require__, /*! ../apps/addtocart-init */ \"./src/js/apps/addtocart-init.js\")).then(function (module) {\n    var addToCart = module[\"default\"];\n    addToCart();\n    return true;\n  })[\"catch\"](function () {\n    return false;\n  });\n};\n/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (openAddToCart);\n\n//# sourceURL=webpack://adams-theme/./src/js/utility/open-addtocart.js?");

/***/ }),

/***/ "./src/css/collection.css":
/*!********************************!*\
  !*** ./src/css/collection.css ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://adams-theme/./src/css/collection.css?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	(() => {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = (chunkId) => {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return "" + {"vendors-node_modules_svelte_internal_index_mjs":"4e764","addtocart-init":"a15ac"}[chunkId] + ".bundle.js";
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get mini-css chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference all chunks
/******/ 		__webpack_require__.miniCssF = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return "" + chunkId + ".bundle.css";
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	(() => {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "adams-theme:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = (url, done, key, chunkId) => {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 		
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = (prev, event) => {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach((fn) => (fn(event)));
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		var scriptUrl;
/******/ 		if (__webpack_require__.g.importScripts) scriptUrl = __webpack_require__.g.location + "";
/******/ 		var document = __webpack_require__.g.document;
/******/ 		if (!scriptUrl && document) {
/******/ 			if (document.currentScript)
/******/ 				scriptUrl = document.currentScript.src;
/******/ 			if (!scriptUrl) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				if(scripts.length) {
/******/ 					var i = scripts.length - 1;
/******/ 					while (i > -1 && (!scriptUrl || !/^http(s?):/.test(scriptUrl))) scriptUrl = scripts[i--].src;
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 		// When supporting browsers where an automatic publicPath is not supported you must specify an output.publicPath manually via configuration
/******/ 		// or pass an empty string ("") and set the __webpack_public_path__ variable from your code to use your own logic.
/******/ 		if (!scriptUrl) throw new Error("Automatic publicPath is not supported in this browser");
/******/ 		scriptUrl = scriptUrl.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/");
/******/ 		__webpack_require__.p = scriptUrl;
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"collection": 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = (chunkId, promises) => {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = (event) => {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 		
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkadams_theme"] = self["webpackChunkadams_theme"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/js/collection.js");
/******/ 	
/******/ })()
;